import SortHeadingContainer from './sort_heading_container';

const SortHeading = SortHeadingContainer;

export default SortHeading;
